import base from '../base';
export default {
	color: base.colors.primary,
	fontSize: 50,
	fontFamily: 'Titillium Web',
};
